import React from "react";
import { Typography, Box } from "@mui/material";
import NoData from "../../Assets/Icons/Map/NoDataMap.svg";

function NoDataMap(props) {
  return (
<div className="mytable">
      <div className="cell">
        <div >
        {/* <Typography style={{ color: "#909090", fontSize: "16px",marginLeft:"20px",fontWeight:600 }}>
          {props.text}
        </Typography> */}
        <Box sx={{display:"flex",margin:"auto",ml:-10,mt:-15}}>
          <img src={NoData} alt="not found" height={60}></img>
        </Box>
        </div>
      </div>
    </div>
  );
}

export default NoDataMap;
